
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class SessaoVazia extends Vue {
  @Prop({ default: "Ops!" }) titulo!: string;
}
